const {defaults} = require('axios');
let url = window.location.href;
let arr = url.split('/');
const BASE_URL = 'https://staging.ibottt.com';
defaults.withCredentials = true

module.exports = {
  BASE_URL: BASE_URL,
};
